import { TableWrapper, TableToolbar, Table } from 'melp-design/components';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DownloadXlsAction } from 'components/actions';
import { useSearchParams } from 'utils/navigation';
import { APP } from 'config';
import {
  recognitionAllowancesFiltersSchema,
  useExportAllowancesToXls,
  useRecognitionAllowances,
} from 'store/recognition-allowances';
import { EmployeeCell } from 'components/table';
import { CompanyScopeInfoMessage } from 'containers/employees';
import AssignedAllowanceDetails from './AssignedAllowanceDetails';

export const RecognitionsAllowancesList = () => {
  const { t } = useTranslation();
  const { searchParams: filters, navigate } = useSearchParams(
    recognitionAllowancesFiltersSchema,
  );

  const { data: allowances, isLoading } = useRecognitionAllowances(filters);

  const { mutate: exportToXls, isLoading: isExportingToXls } =
    useExportAllowancesToXls();

  return (
    <TableWrapper>
      <TableToolbar>
        <Stack gap={1}>
          <CompanyScopeInfoMessage />

          <Stack direction="row" justifyContent="end">
            <DownloadXlsAction
              listLength={allowances?.total ?? 0}
              exportToExcel={() => exportToXls()}
              loading={isExportingToXls}
            />
          </Stack>
        </Stack>
      </TableToolbar>

      <Table
        data={allowances?.items ?? []}
        isLoading={isLoading}
        columns={[
          {
            id: 'employee',
            header: t('entity_type.employee'),
            cell: ({ row: { original: allowance } }) => (
              <EmployeeCell
                employee={{
                  id: allowance.id,
                  fullName: allowance.fullName,
                }}
              />
            ),
          },
          {
            id: 'assignedAllowance',
            header: t('recognition.allowanceOverviewAssignedAllowance'),
            cell: ({ row: { original: allowance } }) =>
              allowance.assignedAllowance ? (
                <Stack direction="row" gap="5px" justifyContent="right">
                  {allowance.assignedAllowance}
                  <AssignedAllowanceDetails employeeId={allowance.id} />
                </Stack>
              ) : (
                allowance.assignedAllowance
              ),
            meta: { align: 'right' },
          },
          {
            id: 'spentPoints',
            header: t('recognition.allowanceOverviewSpentPoints'),
            cell: ({ row: { original: allowance } }) => allowance.spentPoints,
            meta: { align: 'right' },
          },
          {
            id: 'balance',
            header: t('benefitExpenses.remaining'),
            cell: ({ row: { original: allowance } }) => allowance.balance,
            meta: { align: 'right' },
          },
        ]}
        pagination={
          allowances && {
            count: allowances.total,
            page: filters.page,
            pageSize: filters.pageSize,
            pageSizeOptions: APP.pagination.defaults.pageSize,
            onChange: (page, pageSize) => {
              navigate({ params: { page, pageSize } });
            },
          }
        }
      />
    </TableWrapper>
  );
};
